import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PasswordManagementActions from './password-management.actions';
import { PasswordManagementService } from '../../http/password-management.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import * as UserSessionActions from '../user-session/user-session.actions';

export const submitUsernameEffect = createEffect(
  (
    actions$ = inject(Actions),
    router = inject(Router),
    passwordManagementService = inject(PasswordManagementService),
  ) =>
    actions$.pipe(
      ofType(PasswordManagementActions.submitUsernameForPasswordRecovery),
      switchMap((action) =>
        passwordManagementService
          .submitUsernameForRecovery(action.username)
          .pipe(
            map(() => {
              router.navigate([], {
                queryParams: { success: true },
              });

              return PasswordManagementActions.submitUsernameForPasswordRecoverySuccess();
            }),
            catchError(() =>
              of(
                PasswordManagementActions.submitUsernameForPasswordRecoveryError(),
              ),
            ),
          ),
      ),
    ),
  { functional: true },
);

export const resetPasswordEffect = createEffect(
  (
    actions$ = inject(Actions),
    router = inject(Router),
    passwordManagementService = inject(PasswordManagementService),
  ) =>
    actions$.pipe(
      ofType(PasswordManagementActions.resetPassword),
      switchMap((action) =>
        passwordManagementService
          .resetPassword(action.password, action.token)
          .pipe(
            map(() => {
              router.navigate(['/home']);
              return UserSessionActions.getSession();
            }),
            catchError((res) => {
              if (!res.error?.password) {
                router.navigate(['/forgot'], {
                  queryParams: { error: true },
                });
              }
              return of(
                PasswordManagementActions.resetPasswordError({
                  errors: { ...res.error, status: res.status },
                }),
              );
            }),
          ),
      ),
    ),
  { functional: true },
);
